module.exports = "<ol class=message__detail__breadcrumb> <li ng-repeat=\"item in breadcrumbs track by $index\" class=ng-scope> <a ng-class=\"{active: ($index !== paths.length -1)}\" ui-sref=\"{{ item.path }}\"> {{ item.name }}</a> </li> </ol> <div class=message__detail> <h2 class=message__detail__title> {{ message.noticeTitle }} </h2> <p class=message__detail__time> {{ message.createTime }} </p> <div ng-bind-html=to_trusted(message.noticeContent)></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/main/message/views/message.html
// module id = 3HG3
// module chunks = 0